export enum ContentTypeEnum {
  APPLICATION_JSON = 'application/json',
  MULTIPART_FORM = 'multipart/form-data',
}
